export const DEFAULT_SWAPPER_DONATION_BPS = '30'
